module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.className,
    on: {
      "click": _vm.click
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-66d885d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiFlatButton.vue
// module id = 63
// module chunks = 0